import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {loadingIndicatorAttrs} from 'notebook/util/ExportInstrumentation';
import getTestProps from 'test/lib/cypress/getTestProps';
import Spinner from 'ui-library/Spinner';

/**
 * @deprecated Use `Spinner` directly instead.
 */
export default function HorizontalThrobber(): JSX.Element {
  return (
    <Spinner
      classNames={css(styles.spinner)}
      {...loadingIndicatorAttrs()}
      {...getTestProps({component: 'HorizontalThrobber', element: 'root'})}
    >
      Loading...
    </Spinner>
  );
}

interface CenteredHorizontalThrobberProps {
  suppressPadding?: boolean;
  className?: string;
}

/**
 * @deprecated Use `CenteredSpinner` directly instead.
 */
export function CenteredHorizontalThrobber({
  suppressPadding = false,
  className,
}: CenteredHorizontalThrobberProps): JSX.Element {
  return (
    <div
      className={classNames(
        css(styles.centeringWrapper),
        {[css(styles.paddedWrapper)]: !suppressPadding},
        className
      )}
    >
      <HorizontalThrobber />
    </div>
  );
}

const styles = StyleSheet.create({
  spinner: {
    margin: '0 14px 0',
    textIndent: '-9999px',
  },
  centeringWrapper: {
    textAlign: 'center',
  },
  paddedWrapper: {
    padding: '20px',
  },
});
